module.exports = __webpack_public_path__ + "media/metronic/_theme/media/demos/preview/demo12-c304cc847e8d749a42ce5218d910ec6a.jpg";